import { render, staticRenderFns } from "./Seollal.vue?vue&type=template&id=01eff80f&scoped=true&"
import script from "./Seollal.vue?vue&type=script&lang=js&"
export * from "./Seollal.vue?vue&type=script&lang=js&"
import style0 from "./Seollal.vue?vue&type=style&index=0&id=01eff80f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eff80f",
  null
  
)

export default component.exports